import { Box } from "@mui/material"
import { useEffect, useRef, useState } from "react"

import { UDAux } from "../UDesign/Attachments/UDAux"
import { UDSetup } from "../UDesign/UDSetup"
import { UDStaging } from "../UDesign/UDStaging"

import { UDQuickRx } from "./UDQuickRx"

import { WeSetup } from "../WeDesign/WeSetup/WeSetup"
import { WeStaging } from "../WeDesign/WeStaging/WeStaging"
import { UDOrder } from "./order/UDOrder"
import { UDReviewMod } from "./ReviewMod/UDReviewMod"

import { useAppDispatch, useAppSelector } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"
import UDQuickStaging from "../UDesign/UDQuickStaging"
import { setCurRightPage } from "../udTreatSlice"
import { WeTest } from "../WeDesign/WeTest/WeTest"
import { UDRetainerRx } from "./UDRetainerRx"

const offTmpByHistory = ["UDAux"]
export function RightPages(props: any) {
  const { curRightPage, openHistorySplitView, isShowExtractedMsg } =
    useAppSelector((state: RootState) => state.udTreatService)
  const [slideIn, setSlideIn] = useState(false)
  const curPage = useRef("")
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (curPage.current === curRightPage) return
    setSlideIn(false) // Slide current page out
    // Delay 1 seconds
    curPage.current = curRightPage
    setSlideIn(true) // Slide new page
  }, [curRightPage])
  const onClosePage = () => {
    console.log("====onClosePage")
    dispatch(setCurRightPage(""))
  }
  // if open redinement-history, will close some window
  useEffect(() => {
    if (openHistorySplitView) {
      if (offTmpByHistory.includes(curRightPage)) {
        dispatch(setCurRightPage(""))
      }
    }
  }, [openHistorySplitView])

  function getPage(pageName: string) {
    switch (pageName) {
      case "QuickRx":
        return <UDQuickRx onClose={onClosePage} />
      case "RetainerRx":
        return <UDRetainerRx onClose={onClosePage} />
      case "UDSetup":
        return <UDSetup onClose={onClosePage} />
      case "UDStaging":
        return <UDStaging onClose={onClosePage} />
      case "QuickStaging":
        return <UDQuickStaging onClose={onClosePage} />
      case "UDAux":
        return <UDAux onClose={onClosePage} />
      case "ReviewMod":
        return <UDReviewMod onClose={onClosePage} />
      case "Order":
        return <UDOrder onClose={onClosePage} />
      case "WeSetup":
        return <WeSetup onClose={onClosePage} />
      case "WeStaging":
        return <WeStaging onClose={onClosePage} />
      case "WeAux":
        // return <WeAux onClose={onClosePage} />
        return <UDAux onClose={onClosePage} />
      case "WeTest":
        return <WeTest onClose={onClosePage} />
      default:
        return <p>Page: {pageName} </p>
    }
    return <Box sx={{ w: 100, h: 100 }} />
  }

  return curRightPage && getPage(curRightPage)
}
